let category_list=[
	{
		title:'面膜',
		title_en:'Facial Mask',
		list:[
			{
				id:'a1',
				title:'嘭嘭水润面膜',
				home:[
					require('@/assets/image/嘭嘭水润面膜/主图/20180815_151629_173.jpg'),
				],
				list:[
					require('@/assets/image/嘭嘭水润面膜/20180815_151629_176.jpg'),
					require('@/assets/image/嘭嘭水润面膜/20180815_151629_178.jpg'),
					require('@/assets/image/嘭嘭水润面膜/20180815_151629_179.jpg'),
					require('@/assets/image/嘭嘭水润面膜/20180815_151629_180.jpg'),
					require('@/assets/image/嘭嘭水润面膜/20180815_151629_181.jpg'),
					require('@/assets/image/嘭嘭水润面膜/20180815_151629_182.jpg'),
					require('@/assets/image/嘭嘭水润面膜/20180815_151629_183.jpg'),
					require('@/assets/image/嘭嘭水润面膜/20180815_151629_184.jpg'),
					require('@/assets/image/嘭嘭水润面膜/20180815_151629_185.jpg'),
					require('@/assets/image/嘭嘭水润面膜/20180815_151629_186.jpg'),
					require('@/assets/image/嘭嘭水润面膜/20180815_151629_187.jpg'),
					require('@/assets/image/嘭嘭水润面膜/20180815_151629_188.jpg'),
					require('@/assets/image/嘭嘭水润面膜/20180815_151629_189.jpg'),
					require('@/assets/image/嘭嘭水润面膜/20180815_151629_190.jpg'),
					require('@/assets/image/嘭嘭水润面膜/20180815_151629_191.jpg'),
				]
			},
			{
				id:'a2',
				title:'保湿呼吸面膜',
				home:[
					require('@/assets/image/保湿呼吸面膜/主图/20180815_151844_194.jpg'),
				],
				list:[
					require('@/assets/image/保湿呼吸面膜/20180815_151844_196.jpg'),
					require('@/assets/image/保湿呼吸面膜/20180815_151844_197.jpg'),
					require('@/assets/image/保湿呼吸面膜/20180815_151844_198.jpg'),
					require('@/assets/image/保湿呼吸面膜/20180815_151844_199.jpg'),
					require('@/assets/image/保湿呼吸面膜/20180815_151844_200.jpg'),
					require('@/assets/image/保湿呼吸面膜/20180815_151844_201.jpg'),
					require('@/assets/image/保湿呼吸面膜/20180815_151844_202.jpg'),
					require('@/assets/image/保湿呼吸面膜/20180815_151844_203.jpg'),
					require('@/assets/image/保湿呼吸面膜/20180815_151844_204.jpg'),
					require('@/assets/image/保湿呼吸面膜/20180815_151844_205.jpg'),
					require('@/assets/image/保湿呼吸面膜/20180815_151844_206.jpg'),
					require('@/assets/image/保湿呼吸面膜/20180815_151844_207.jpg'),
					require('@/assets/image/保湿呼吸面膜/20180815_151844_208.jpg'),
					require('@/assets/image/保湿呼吸面膜/20180815_151844_209.jpg'),
					require('@/assets/image/保湿呼吸面膜/20180815_151844_210.jpg'),
					require('@/assets/image/保湿呼吸面膜/20180815_151844_211.jpg'),
					require('@/assets/image/保湿呼吸面膜/20180815_151844_212.jpg'),
					require('@/assets/image/保湿呼吸面膜/20180815_151844_213.jpg'),
					require('@/assets/image/保湿呼吸面膜/20180815_151844_214.jpg'),
					require('@/assets/image/保湿呼吸面膜/20180815_151844_215.jpg'),
					require('@/assets/image/保湿呼吸面膜/20180815_151844_216.jpg'),
					
				]
			},
			{
				id:'a3',
				title:'倦容退散面膜',
				home:[
					require('@/assets/image/倦容退散面膜/主图/20180815_152858_218.jpg'),
				],
				list:[
					require('@/assets/image/倦容退散面膜/20180815_152858_220.jpg'),
					require('@/assets/image/倦容退散面膜/20180815_152858_221.jpg'),
					require('@/assets/image/倦容退散面膜/20180815_152858_222.jpg'),
					require('@/assets/image/倦容退散面膜/20180815_152858_223.jpg'),
					require('@/assets/image/倦容退散面膜/20180815_152858_224.jpg'),
					require('@/assets/image/倦容退散面膜/20180815_152858_225.jpg'),
					require('@/assets/image/倦容退散面膜/20180815_152858_226.jpg'),
					require('@/assets/image/倦容退散面膜/20180815_152858_227.jpg'),
					require('@/assets/image/倦容退散面膜/20180815_152858_228.jpg'),
					require('@/assets/image/倦容退散面膜/20180815_152858_229.jpg'),
					require('@/assets/image/倦容退散面膜/20180815_152858_230.jpg'),
					require('@/assets/image/倦容退散面膜/20180815_152858_231.jpg'),
					require('@/assets/image/倦容退散面膜/20180815_152858_232.jpg'),
					require('@/assets/image/倦容退散面膜/20180815_152858_233.jpg'),
					
				]
			},
			{
				id:'a4',
				title:'鎏金面膜',
				home:[
					require('@/assets/image/鎏金面膜/images/鎏金面膜_02.jpg'),
				],
				list:[
					require('@/assets/image/鎏金面膜/images/鎏金面膜_02.jpg'),
					require('@/assets/image/鎏金面膜/images/鎏金面膜_03.jpg'),
					require('@/assets/image/鎏金面膜/images/鎏金面膜_04.jpg'),
					require('@/assets/image/鎏金面膜/images/鎏金面膜_05.jpg')
					
				]
			},
			{
				id:'a5',
				title:'鎏金面膜+珍银面膜',
				home:[
					require('@/assets/image/鎏金面膜+珍银面膜/鎏金面膜+珍银面膜_02.jpg'),
				],
				list:[
					require('@/assets/image/鎏金面膜+珍银面膜/鎏金面膜+珍银面膜_01.jpg'),
					require('@/assets/image/鎏金面膜+珍银面膜/鎏金面膜+珍银面膜_02.jpg'),
					require('@/assets/image/鎏金面膜+珍银面膜/鎏金面膜+珍银面膜_03.jpg'),
					require('@/assets/image/鎏金面膜+珍银面膜/鎏金面膜+珍银面膜_04.jpg'),
					require('@/assets/image/鎏金面膜+珍银面膜/鎏金面膜+珍银面膜_05.jpg'),
					require('@/assets/image/鎏金面膜+珍银面膜/鎏金面膜+珍银面膜_06.jpg'),
					require('@/assets/image/鎏金面膜+珍银面膜/鎏金面膜+珍银面膜_07.jpg'),
					
				]
			},
			{
				id:'a6',
				title:'三层渗透面膜（白色）',
				home:[
					require('@/assets/image/三层渗透面膜（白色）/20190418_154809_001.jpg'),
				],
				list:[
					require('@/assets/image/三层渗透面膜（白色）/20190418_154809_001.jpg'),
					require('@/assets/image/三层渗透面膜（白色）/20190418_154809_002.jpg'),
					require('@/assets/image/三层渗透面膜（白色）/20190418_154809_003.jpg'),
					require('@/assets/image/三层渗透面膜（白色）/20190418_154809_004.jpg'),
					require('@/assets/image/三层渗透面膜（白色）/20190418_154809_005.jpg'),
					require('@/assets/image/三层渗透面膜（白色）/20190418_154809_006.jpg'),
					require('@/assets/image/三层渗透面膜（白色）/20190418_154809_007.jpg'),
					require('@/assets/image/三层渗透面膜（白色）/20190418_154809_008.jpg'),
					
				]
			},
			{
				id:'a7',
				title:'银珍面膜',
				home:[
					require('@/assets/image/银珍面膜切片/银珍/珍银面膜--OK_01.jpg'),
				],
				list:[
					require('@/assets/image/银珍面膜切片/银珍/珍银面膜--OK_01.jpg'),
					require('@/assets/image/银珍面膜切片/银珍/珍银面膜--OK_02.jpg'),
					require('@/assets/image/银珍面膜切片/银珍/珍银面膜--OK_03.jpg'),
					require('@/assets/image/银珍面膜切片/银珍/珍银面膜--OK_04.jpg'),
					require('@/assets/image/银珍面膜切片/银珍/珍银面膜--OK_05.jpg'),
					
				]
			},
			{
				id:'a8',
				title:'雪吻丝滑',
				home:[
					require('@/assets/image/雪吻丝滑/20170704_135648_081.jpg'),
				],
				list:[
					require('@/assets/image/雪吻丝滑/20170704_135648_081.jpg'),
					require('@/assets/image/雪吻丝滑/20170704_135648_082.jpg'),
					require('@/assets/image/雪吻丝滑/20170704_135648_083.jpg'),
					require('@/assets/image/雪吻丝滑/20170704_135648_084.jpg'),
					require('@/assets/image/雪吻丝滑/20170704_135648_085.jpg'),
					require('@/assets/image/雪吻丝滑/20170704_135648_086.jpg'),
					require('@/assets/image/雪吻丝滑/20170704_135648_087.jpg'),
					require('@/assets/image/雪吻丝滑/20170704_135648_088.jpg'),
					require('@/assets/image/雪吻丝滑/20170704_135648_089.jpg'),
					require('@/assets/image/雪吻丝滑/20170704_135648_090.jpg'),
					require('@/assets/image/雪吻丝滑/20170704_135648_091.jpg'),
					require('@/assets/image/雪吻丝滑/20170704_135648_092.jpg'),
					require('@/assets/image/雪吻丝滑/20170704_135648_093.jpg'),
					require('@/assets/image/雪吻丝滑/20170704_135648_094.jpg'),
					require('@/assets/image/雪吻丝滑/20170704_135648_095.jpg'),
					require('@/assets/image/雪吻丝滑/20170704_135648_096.jpg'),
					require('@/assets/image/雪吻丝滑/20170704_135648_097.jpg'),
					require('@/assets/image/雪吻丝滑/20170704_135648_098.jpg'),
					require('@/assets/image/雪吻丝滑/20170704_135648_099.jpg'),
					
				]
			},
		]
	},
	{
		title:'精油',
		title_en:'Essential Oil',
		list:[
			{
				id:'b1',
				title:'精油水薰衣草',
				home:[
					require('@/assets/image/精油水薰衣草/9.jpg'),
				],
				list:[
					require('@/assets/image/精油水薰衣草/1.jpg'),
					require('@/assets/image/精油水薰衣草/2.jpg'),
					require('@/assets/image/精油水薰衣草/3.jpg'),
					require('@/assets/image/精油水薰衣草/4.jpg'),
					require('@/assets/image/精油水薰衣草/5.jpg'),
					require('@/assets/image/精油水薰衣草/6.jpg'),
					require('@/assets/image/精油水薰衣草/7.jpg'),
					require('@/assets/image/精油水薰衣草/8.jpg'),
					require('@/assets/image/精油水薰衣草/9.jpg'),
					require('@/assets/image/精油水薰衣草/10.jpg'),
				]
			},
			{
				id:'b2',
				title:'精油水天竺葵',
				home:[
					require('@/assets/image/精油水天竺葵/美容水(绿)_05.jpg'),
				],
				list:[
					require('@/assets/image/精油水天竺葵/美容水(绿)_01.jpg'),
					require('@/assets/image/精油水天竺葵/美容水(绿)_02.jpg'),
					require('@/assets/image/精油水天竺葵/美容水(绿)_03.jpg'),
					require('@/assets/image/精油水天竺葵/美容水(绿)_04.jpg'),
					require('@/assets/image/精油水天竺葵/美容水(绿)_05.jpg')
				]
			},
			{
				id:'b3',
				title:'精油水玫瑰',
				home:[
					require('@/assets/image/精油水玫瑰/美容水(蓝)_05.jpg'),
				],
				list:[
					require('@/assets/image/精油水玫瑰/美容水(蓝)_01.jpg'),
					require('@/assets/image/精油水玫瑰/美容水(蓝)_02.jpg'),
					require('@/assets/image/精油水玫瑰/美容水(蓝)_03.jpg'),
					require('@/assets/image/精油水玫瑰/美容水(蓝)_04.jpg'),
					require('@/assets/image/精油水玫瑰/美容水(蓝)_05.jpg')
				]
			},
		]
	},
	{
		title:'卸妆',
		title_en:'Remove Makeup',
		list:[
			{
				id:'c1',
				title:'泉润卸妆喷雾',
				home:[
					require('@/assets/image/泉润卸妆喷雾/主图/20180815_145911_023.jpg'),
				],
				list:[
					require('@/assets/image/泉润卸妆喷雾/20180815_145911_027.jpg'),
					require('@/assets/image/泉润卸妆喷雾/20180815_145911_028.jpg'),
					require('@/assets/image/泉润卸妆喷雾/20180815_145911_029.jpg'),
					require('@/assets/image/泉润卸妆喷雾/20180815_145911_030.jpg'),
					require('@/assets/image/泉润卸妆喷雾/20180815_145911_031.jpg'),
					require('@/assets/image/泉润卸妆喷雾/20180815_145911_032.jpg'),
					require('@/assets/image/泉润卸妆喷雾/20180815_145911_033.jpg'),
					require('@/assets/image/泉润卸妆喷雾/20180815_145911_034.jpg'),
					require('@/assets/image/泉润卸妆喷雾/20180815_145911_035.jpg'),
					require('@/assets/image/泉润卸妆喷雾/20180815_145911_036.jpg'),
					require('@/assets/image/泉润卸妆喷雾/20180815_145911_037.jpg'),
					require('@/assets/image/泉润卸妆喷雾/20180815_145911_038.jpg'),
					require('@/assets/image/泉润卸妆喷雾/20180815_145911_039.jpg'),
					require('@/assets/image/泉润卸妆喷雾/20180815_145911_040.jpg'),
					require('@/assets/image/泉润卸妆喷雾/20180815_145911_041.jpg'),
				]
			},
			{
				id:'c2',
				title:'泉润卸妆喷雾10ml',
				home:[
					require('@/assets/image/泉润卸妆喷雾10ml/3.jpg'),
				],
				list:[
					require('@/assets/image/泉润卸妆喷雾10ml/1.jpg'),
					require('@/assets/image/泉润卸妆喷雾10ml/2.jpg'),
					require('@/assets/image/泉润卸妆喷雾10ml/3.jpg'),
					require('@/assets/image/泉润卸妆喷雾10ml/4.jpg'),
					require('@/assets/image/泉润卸妆喷雾10ml/5.jpg'),
					require('@/assets/image/泉润卸妆喷雾10ml/6.jpg'),
					require('@/assets/image/泉润卸妆喷雾10ml/7.jpg'),
					require('@/assets/image/泉润卸妆喷雾10ml/8.jpg'),
					require('@/assets/image/泉润卸妆喷雾10ml/9.jpg'),
					require('@/assets/image/泉润卸妆喷雾10ml/10.jpg'),
					require('@/assets/image/泉润卸妆喷雾10ml/11.jpg'),
					require('@/assets/image/泉润卸妆喷雾10ml/12.jpg'),
				]
			},
			{
				id:'c3',
				title:'泉润卸妆水',
				home:[
					require('@/assets/image/泉润卸妆水/20190611_113036_002.jpg'),
				],
				list:[
					require('@/assets/image/泉润卸妆水/20190611_113036_002.jpg'),
					require('@/assets/image/泉润卸妆水/20190611_113036_003.jpg'),
					require('@/assets/image/泉润卸妆水/20190611_113036_005.jpg'),
					require('@/assets/image/泉润卸妆水/20190611_113036_007.jpg'),
					require('@/assets/image/泉润卸妆水/20190611_113036_008.jpg'),
					require('@/assets/image/泉润卸妆水/20190611_113036_009.jpg'),
					require('@/assets/image/泉润卸妆水/20190611_113036_010.jpg'),
					require('@/assets/image/泉润卸妆水/20190611_113036_011.jpg'),
					require('@/assets/image/泉润卸妆水/20190611_113036_012.jpg'),
					require('@/assets/image/泉润卸妆水/20190611_113036_013.jpg'),
					require('@/assets/image/泉润卸妆水/20190611_113036_014.jpg'),
					require('@/assets/image/泉润卸妆水/20190611_113036_015.jpg'),
					require('@/assets/image/泉润卸妆水/20190611_113036_016.jpg'),
				]
			},
			
		]
	},
	{
		title:'洁面奶',
		title_en:'Cleansing Milk',
		list:[
			
			{
				id:'d1',
				title:'自在畅饮洁面乳',
				home:[
					require('@/assets/image/自在畅饮洁面乳/主图/20180815_150347_067.jpg'),
				],
				list:[
					require('@/assets/image/自在畅饮洁面乳/20180815_150347_070.jpg'),
					require('@/assets/image/自在畅饮洁面乳/20180815_150347_071.jpg'),
					require('@/assets/image/自在畅饮洁面乳/20180815_150347_072.jpg'),
					require('@/assets/image/自在畅饮洁面乳/20180815_150347_073.jpg'),
					require('@/assets/image/自在畅饮洁面乳/20180815_150347_074.jpg'),
					require('@/assets/image/自在畅饮洁面乳/20180815_150347_076.jpg'),
					require('@/assets/image/自在畅饮洁面乳/20180815_150347_077.jpg'),
					require('@/assets/image/自在畅饮洁面乳/20180815_150347_078.jpg'),
					require('@/assets/image/自在畅饮洁面乳/20180815_150347_080.jpg'),
					require('@/assets/image/自在畅饮洁面乳/20180815_150347_082.jpg'),
					require('@/assets/image/自在畅饮洁面乳/20180815_150347_083.jpg'),
					require('@/assets/image/自在畅饮洁面乳/20180815_150347_084.jpg'),
					require('@/assets/image/自在畅饮洁面乳/20180815_150347_085.jpg'),
					require('@/assets/image/自在畅饮洁面乳/20180815_150347_086.jpg'),
				]
			},
			
			
		]
	},
	{
		title:'套装',
		title_en:'Suit',
		list:[
			{
				id:'t1',
				title:'光彩立现套装',
				home:[
					require('@/assets/image/光彩立现套装/20190612_132334_018.jpg'),
				],
				list:[
					require('@/assets/image/光彩立现套装/20190612_132334_015.jpg'),
					require('@/assets/image/光彩立现套装/20190612_132334_016.jpg'),
					require('@/assets/image/光彩立现套装/20190612_132334_017.jpg'),
					require('@/assets/image/光彩立现套装/20190612_132334_018.jpg'),
					require('@/assets/image/光彩立现套装/20190612_132334_019.jpg'),
					require('@/assets/image/光彩立现套装/20190612_132334_020.jpg'),
					require('@/assets/image/光彩立现套装/20190612_132334_021.jpg'),
					require('@/assets/image/光彩立现套装/20190612_132334_022.jpg'),
					require('@/assets/image/光彩立现套装/20190612_132334_023.jpg'),
					require('@/assets/image/光彩立现套装/20190612_132334_024.jpg'),
					require('@/assets/image/光彩立现套装/20190612_132334_025.jpg'),
					require('@/assets/image/光彩立现套装/20190612_132334_026.jpg'),
					require('@/assets/image/光彩立现套装/20190612_132334_027.jpg'),
					require('@/assets/image/光彩立现套装/20190612_132334_028.jpg'),
				]
			},
			{
				id:'t2',
				title:'硫磺套',
				home:[
					require('@/assets/image/硫磺套/硫磺温泉毛孔净化套_04.jpg'),
				],
				list:[
					require('@/assets/image/硫磺套/硫磺温泉毛孔净化套.jpg'),
					
				]
			},
			{
				id:'t3',
				title:'泉润水润kiss套',
				home:[
					require('@/assets/image/泉润水润kiss套/20170314泉润gaga_06.jpg'),
				],
				list:[
					require('@/assets/image/泉润水润kiss套/20170314泉润gaga.jpg'),
					
				]
			},
			{
				id:'t4',
				title:'泉润肌如雪5件套',
				home:[
					require('@/assets/image/泉润肌如雪5件套/肌如初雪套装_10.jpg'),
				],
				list:[
					require('@/assets/image/泉润肌如雪5件套/肌如初雪套装_01.jpg'),
					require('@/assets/image/泉润肌如雪5件套/肌如初雪套装_02.jpg'),
					require('@/assets/image/泉润肌如雪5件套/肌如初雪套装_03.jpg'),
					require('@/assets/image/泉润肌如雪5件套/肌如初雪套装_04.jpg'),
					require('@/assets/image/泉润肌如雪5件套/肌如初雪套装_05.jpg'),
					require('@/assets/image/泉润肌如雪5件套/肌如初雪套装_06.jpg'),
					require('@/assets/image/泉润肌如雪5件套/肌如初雪套装_07.jpg'),
					require('@/assets/image/泉润肌如雪5件套/肌如初雪套装_08.jpg'),
					require('@/assets/image/泉润肌如雪5件套/肌如初雪套装_09.jpg'),
					require('@/assets/image/泉润肌如雪5件套/肌如初雪套装_10.jpg'),
					
				]
			},
			{
				id:'t5',
				title:'三层润燥8件套',
				home:[
					require('@/assets/image/三层润燥8件套/20190611_173512_079.jpg'),
				],
				list:[
					require('@/assets/image/泉润肌如雪5件套/肌如初雪套装_01.jpg'),
					require('@/assets/image/泉润肌如雪5件套/肌如初雪套装_02.jpg'),
					require('@/assets/image/泉润肌如雪5件套/肌如初雪套装_03.jpg'),
					require('@/assets/image/泉润肌如雪5件套/肌如初雪套装_04.jpg'),
					require('@/assets/image/泉润肌如雪5件套/肌如初雪套装_05.jpg'),
					require('@/assets/image/泉润肌如雪5件套/肌如初雪套装_06.jpg'),
					require('@/assets/image/泉润肌如雪5件套/肌如初雪套装_07.jpg'),
					require('@/assets/image/泉润肌如雪5件套/肌如初雪套装_08.jpg'),
					require('@/assets/image/泉润肌如雪5件套/肌如初雪套装_09.jpg'),
					require('@/assets/image/泉润肌如雪5件套/肌如初雪套装_10.jpg'),
					
				]
			},
		]
	},
	{
		title:'皮肤',
		title_en:'Skin',
		list:[
			
			{
				id:'e1',
				title:'泉润气垫BB霜',
				home:[
					require('@/assets/image/泉润气垫BB霜/主图/20180815_150119_044.jpg'),
				],
				list:[
					require('@/assets/image/泉润气垫BB霜/20180815_150119_047.jpg'),
					require('@/assets/image/泉润气垫BB霜/20180815_150119_048.jpg'),
					require('@/assets/image/泉润气垫BB霜/20180815_150119_049.jpg'),
					require('@/assets/image/泉润气垫BB霜/20180815_150119_050.jpg'),
					require('@/assets/image/泉润气垫BB霜/20180815_150119_052.jpg'),
					require('@/assets/image/泉润气垫BB霜/20180815_150119_053.jpg'),
					require('@/assets/image/泉润气垫BB霜/20180815_150119_054.jpg'),
					require('@/assets/image/泉润气垫BB霜/20180815_150119_055.jpg'),
					require('@/assets/image/泉润气垫BB霜/20180815_150119_056.jpg'),
					require('@/assets/image/泉润气垫BB霜/20180815_150119_057.jpg'),
					require('@/assets/image/泉润气垫BB霜/20180815_150119_058.jpg'),
					require('@/assets/image/泉润气垫BB霜/20180815_150119_059.jpg'),
					require('@/assets/image/泉润气垫BB霜/20180815_150119_060.jpg'),
					require('@/assets/image/泉润气垫BB霜/20180815_150119_061.jpg'),
					require('@/assets/image/泉润气垫BB霜/20180815_150119_062.jpg'),
					require('@/assets/image/泉润气垫BB霜/20180815_150119_063.jpg'),
					require('@/assets/image/泉润气垫BB霜/20180815_150119_064.jpg'),
					require('@/assets/image/泉润气垫BB霜/20180815_150119_065.jpg'),
				]
			},
			{
				id:'e2',
				title:'自在畅饮爽肤水',
				home:[
					require('@/assets/image/自在畅饮爽肤水/主图/20180815_150609_088.jpg'),
				],
				list:[
					require('@/assets/image/自在畅饮爽肤水/20180815_150609_091.jpg'),
					require('@/assets/image/自在畅饮爽肤水/20180815_150609_093.jpg'),
					require('@/assets/image/自在畅饮爽肤水/20180815_150609_095.jpg'),
					require('@/assets/image/自在畅饮爽肤水/20180815_150609_096.jpg'),
					require('@/assets/image/自在畅饮爽肤水/20180815_150609_097.jpg'),
					require('@/assets/image/自在畅饮爽肤水/20180815_150609_098.jpg'),
					require('@/assets/image/自在畅饮爽肤水/20180815_150609_099.jpg'),
					require('@/assets/image/自在畅饮爽肤水/20180815_150609_100.jpg'),
					require('@/assets/image/自在畅饮爽肤水/20180815_150609_101.jpg'),
					require('@/assets/image/自在畅饮爽肤水/20180815_150609_102.jpg'),
					require('@/assets/image/自在畅饮爽肤水/20180815_150609_103.jpg'),
					require('@/assets/image/自在畅饮爽肤水/20180815_150609_104.jpg'),
					require('@/assets/image/自在畅饮爽肤水/20180815_150609_105.jpg'),
				]
			},
			{
				id:'e3',
				title:'防晒乳',
				home:[
					require('@/assets/image/防晒乳/主图/20180815_145537_000.jpg'),
				],
				list:[
					require('@/assets/image/防晒乳/20180815_145537_004.jpg'),
					require('@/assets/image/防晒乳/20180815_145537_005.jpg'),
					require('@/assets/image/防晒乳/20180815_145537_006.jpg'),
					require('@/assets/image/防晒乳/20180815_145537_007.jpg'),
					require('@/assets/image/防晒乳/20180815_145537_009.jpg'),
					require('@/assets/image/防晒乳/20180815_145537_010.jpg'),
					require('@/assets/image/防晒乳/20180815_145537_011.jpg'),
					require('@/assets/image/防晒乳/20180815_145537_012.jpg'),
					require('@/assets/image/防晒乳/20180815_145537_013.jpg'),
					require('@/assets/image/防晒乳/20180815_145537_014.jpg'),
					require('@/assets/image/防晒乳/20180815_145537_015.jpg'),
					require('@/assets/image/防晒乳/20180815_145537_016.jpg'),
					require('@/assets/image/防晒乳/20180815_145537_017.jpg'),
					require('@/assets/image/防晒乳/20180815_145537_018.jpg'),
					require('@/assets/image/防晒乳/20180815_145537_019.jpg'),
					require('@/assets/image/防晒乳/20180815_145537_020.jpg'),
				]
			},
			{
				id:'e4',
				title:'泉润眼霜',
				home:[
					require('@/assets/image/泉润眼霜/眼霜/20180815_151538_146.jpg'),
				],
				list:[
					require('@/assets/image/泉润眼霜/20180815_151538_149.jpg'),
					require('@/assets/image/泉润眼霜/20180815_151538_151.jpg'),
					require('@/assets/image/泉润眼霜/20180815_151538_153.jpg'),
					require('@/assets/image/泉润眼霜/20180815_151538_154.jpg'),
					require('@/assets/image/泉润眼霜/20180815_151538_155.jpg'),
					require('@/assets/image/泉润眼霜/20180815_151538_157.jpg'),
					require('@/assets/image/泉润眼霜/20180815_151538_158.jpg'),
					require('@/assets/image/泉润眼霜/20180815_151538_159.jpg'),
					require('@/assets/image/泉润眼霜/20180815_151538_160.jpg'),
					require('@/assets/image/泉润眼霜/20180815_151538_161.jpg'),
					require('@/assets/image/泉润眼霜/20180815_151538_162.jpg'),
					require('@/assets/image/泉润眼霜/20180815_151538_163.jpg'),
					require('@/assets/image/泉润眼霜/20180815_151538_164.jpg'),
					require('@/assets/image/泉润眼霜/20180815_151538_165.jpg'),
					require('@/assets/image/泉润眼霜/20180815_151538_166.jpg'),
					require('@/assets/image/泉润眼霜/20180815_151538_167.jpg'),
					require('@/assets/image/泉润眼霜/20180815_151538_168.jpg'),
					require('@/assets/image/泉润眼霜/20180815_151538_169.jpg'),
					require('@/assets/image/泉润眼霜/20180815_151538_170.jpg'),
				]
			},
			{
				id:'e5',
				title:'蜜酿',
				home:[
					require('@/assets/image/蜜酿/20180815_154807_238.jpg'),
				],
				list:[
					require('@/assets/image/蜜酿/20180815_154807_238.jpg'),
					require('@/assets/image/蜜酿/20180815_154807_240.jpg'),
					require('@/assets/image/蜜酿/20180815_154807_241.jpg'),
					require('@/assets/image/蜜酿/20180815_154807_242.jpg'),
					require('@/assets/image/蜜酿/20180815_154807_243.jpg'),
					require('@/assets/image/蜜酿/20180815_154807_244.jpg'),
					require('@/assets/image/蜜酿/20180815_154807_245.jpg'),
					require('@/assets/image/蜜酿/20180815_154807_246.jpg'),
					require('@/assets/image/蜜酿/20180815_154807_247.jpg'),
					require('@/assets/image/蜜酿/20180815_154807_248.jpg'),
					require('@/assets/image/蜜酿/20180815_154807_249.jpg'),
					require('@/assets/image/蜜酿/20180815_154807_250.jpg'),
					require('@/assets/image/蜜酿/20180815_154807_251.jpg'),
					require('@/assets/image/蜜酿/20180815_154807_252.jpg'),
					require('@/assets/image/蜜酿/20180815_154807_253.jpg'),
					require('@/assets/image/蜜酿/20180815_154807_254.jpg'),
				]
			},
			{
				id:'e6',
				title:'深海精华',
				home:[
					require('@/assets/image/深海精华/深海精华.jpg'),
				],
				list:[
					require('@/assets/image/深海精华/20190611_153430_038.jpg'),
					require('@/assets/image/深海精华/20190611_153430_039.jpg'),
					require('@/assets/image/深海精华/20190611_153430_040.jpg'),
					require('@/assets/image/深海精华/20190611_153430_041.jpg'),
					require('@/assets/image/深海精华/深海精华.jpg'),
					
				]
			},
			{
				id:'e7',
				title:'深海凝萃',
				home:[
					require('@/assets/image/深海凝萃/20190222_183706_001.jpg'),
				],
				list:[
					require('@/assets/image/深海凝萃/20190222_183706_001.jpg'),
					require('@/assets/image/深海凝萃/20190222_183706_002.jpg'),
					require('@/assets/image/深海凝萃/20190222_183706_003.jpg'),
					require('@/assets/image/深海凝萃/20190222_183706_000.jpg'),
					require('@/assets/image/深海凝萃/20190222_183706_004.jpg'),
					require('@/assets/image/深海凝萃/20190222_183706_005.jpg'),
					require('@/assets/image/深海凝萃/20190222_183706_006.jpg'),
					require('@/assets/image/深海凝萃/20190222_183706_007.jpg'),
					
				]
			},
		]
	},
]
export{
	category_list
}